import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

export function WebhookEventHelpTip({
  title,
  paragraphs,
  placement = 'top',
}: {
  title: string;
  paragraphs: string[];
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
}) {
  return (
    <HelpTooltip
      html={guideTooltipHtml({ title, paragraphs })}
      placement={placement}
      className="ms-1"
    />
  );
}
